import './FavoriteLink.scss';

import React, {useState} from 'react';

import { useSessionUser } from '../../../../../data/hooks/sessionHooks';
import Link from '../../../../elements/Link';


const FavoriteLink = props => {
    const {event, question} = props,
        user = useSessionUser(),
        [busy, setBusy] = useState(false);

    const handleToggleFavorite = () => {
        setBusy(true);

        let original = {...question};

        // perform change  on store
        app.store.dispatch(
            app.actions.questions.update(event.id, question.id, {
                ...question,
                is_favorite: !original.is_favorite,
                favorite_count: original.is_favorite ? original.favorite_count - 1 : original.favorite_count + 1,
                favorite_users: original.is_favorite ? original.favorite_users.filter(id => id != user.id) : [...original.favorite_users, user.id],
            })
        );

        // send change to server
        app.api.questions
            .favorite(event.id, question.id, !question.is_favorite)
            .catch(err => {
                console.error(err);

                // rollback to original if it fails
                app.store.dispatch(event.id, question.id, original);
            })
            .then(() => {
                setBusy(false);
            });
    };

    return <Link onClick={handleToggleFavorite} className={['FavoriteLink', question.is_favorite ? 'on' : 'off'].join(' ')} disabled={busy}></Link>;
};

export default FavoriteLink;
